module.exports = __webpack_public_path__ + "static/media/IMG_4605 from loounge opposite.ccc17afa.JPG";